/** Iconos Material (Google) con la firma `size` usada por la app. */
import SearchRounded from '@mui/icons-material/SearchRounded';
import AddRounded from '@mui/icons-material/AddRounded';
import DeleteOutlineRounded from '@mui/icons-material/DeleteOutlineRounded';
import PlayArrowRounded from '@mui/icons-material/PlayArrowRounded';
import PauseRounded from '@mui/icons-material/PauseRounded';
import SkipNextRounded from '@mui/icons-material/SkipNextRounded';
import SkipPreviousRounded from '@mui/icons-material/SkipPreviousRounded';
import VolumeUpRounded from '@mui/icons-material/VolumeUpRounded';
import VolumeOffRounded from '@mui/icons-material/VolumeOffRounded';
import DragIndicatorRounded from '@mui/icons-material/DragIndicatorRounded';
import GroupRounded from '@mui/icons-material/GroupRounded';
import ContentCopyRounded from '@mui/icons-material/ContentCopyRounded';
import CheckRounded from '@mui/icons-material/CheckRounded';
import KeyboardArrowUpRounded from '@mui/icons-material/KeyboardArrowUpRounded';
import KeyboardArrowDownRounded from '@mui/icons-material/KeyboardArrowDownRounded';
import SyncRounded from '@mui/icons-material/SyncRounded';
import WarningAmberRounded from '@mui/icons-material/WarningAmberRounded';
import LogoutRounded from '@mui/icons-material/LogoutRounded';
import MusicNoteRounded from '@mui/icons-material/MusicNoteRounded';
import WorkspacePremiumRounded from '@mui/icons-material/WorkspacePremiumRounded';
import LinkRounded from '@mui/icons-material/LinkRounded';

function makeIcon(Icon) {
  function IconWrapper({ size = 18, sx, ...rest }) {
    return <Icon sx={{ fontSize: size, ...sx }} {...rest} />;
  }
  IconWrapper.displayName = 'MaterialIcon';
  return IconWrapper;
}

export const IconSearch = makeIcon(SearchRounded);
export const IconPlus = makeIcon(AddRounded);
export const IconTrash = makeIcon(DeleteOutlineRounded);
export const IconPlay = makeIcon(PlayArrowRounded);
export const IconPause = makeIcon(PauseRounded);
export const IconNext = makeIcon(SkipNextRounded);
export const IconPrev = makeIcon(SkipPreviousRounded);
export const IconVolume = makeIcon(VolumeUpRounded);
export const IconVolumeMute = makeIcon(VolumeOffRounded);
export const IconGrip = makeIcon(DragIndicatorRounded);
export const IconUsers = makeIcon(GroupRounded);
export const IconCopy = makeIcon(ContentCopyRounded);
export const IconCheck = makeIcon(CheckRounded);
export const IconChevronUp = makeIcon(KeyboardArrowUpRounded);
export const IconChevronDown = makeIcon(KeyboardArrowDownRounded);
export const IconSync = makeIcon(SyncRounded);
export const IconWarn = makeIcon(WarningAmberRounded);
export const IconExit = makeIcon(LogoutRounded);
export const IconMusic = makeIcon(MusicNoteRounded);
export const IconHost = makeIcon(WorkspacePremiumRounded);
export const IconLink = makeIcon(LinkRounded);
